import {isNil} from 'ramda';

import {
  DrillDownStatisticsLevel,
  useLazySourcingGetDrillDownAdServerRedirectQuery,
} from '@dms/api/core';

import {
  getDrillDownAdServerRequest,
  GetDrillDownAdServerRequestParams,
} from '../utils/getDrillDownAdServerRequest';

/**
 * Returns the `getStockUrlLoader` of the drill down: a row whose make and model are known
 * gets a loader of its ad server search URL, other rows get `null`.
 */
export function useDrillDownStockUrlLoader(
  params: Omit<GetDrillDownAdServerRequestParams, 'levels'>
) {
  const [getDrillDownAdServerRedirect] = useLazySourcingGetDrillDownAdServerRedirectQuery();

  return (levels: DrillDownStatisticsLevel[]) => {
    const request = getDrillDownAdServerRequest({...params, levels});

    if (isNil(request)) {
      return null;
    }

    return () =>
      getDrillDownAdServerRedirect({drillDownAdServerRedirectRequestBody: request})
        .unwrap()
        .then((response) => response.url);
  };
}
